const cohort2026_27 = [
  "Adrianna Skerrett",
  "Alexa Sotelo-Lozada",
  "Andre Vasquez",
  "Anthony Alcalde",
  "Ban Alyunis",
  "Benjamin Sirota Plotnikov",
  "Braelyn Zurek",
  "Branden Neveau",
  "Brian Gutierrez",
  "Carlisya Hyman",
  "Carlos Lage",
  "Christian Iggulden",
  "Daniela Cáceres Capiro",
  "Daniella Barral",
  "Darin Ampofo",
  "Diana Martinez-Juarez",
  "Diego Ponce",
  "Dominic Angello",
  "Dulce Perez",
  "Emily Marshall",
  "Emily Romano",
  "Emina Bukaveric",
  "Eric Li",
  "Gabriel Muselier Alvarez",
  "Hao Tran",
  "Ian DeMilo",
  "Ian Ursi",
  "Jaliyah Weekes",
  "Jayden Pichardo",
  "Joy Weng",
  "Kane Robertson",
  "Katelyn Mao",
  "Kayce Rodriguez",
  "Leena Hatcher",
  "Madyson Bassant",
  "Marely Martinez-Escobar",
  "Maria Cristina Landivar Acha",
  "Micaela Mejia",
  "Nga Goh Horus Chan",
  "Raymond Liu",
  "Samiul Hoque",
  "Santiago Caudillo",
  "Su Bao 'Peter' Phuc Huynh",
  "Tommy Tang",
  "Tyson Scheonwetter",
  "Valentina Di-Majo",
  "Van Vo",
  "Yan Ling Wu",
  "Yonathon Man",
  "Yuanzhou Ye"

];
const cohort2025_26 = [
"Alana Cross",
"Alivia Grissom",
"Alvaro Finol",
"Alyanna Siakkhasone",
"Amy Kollcinaku",
"Angelina Morffi",
"Angelique Aguado",
"Anthony Rodriguez",
"Antonio Street",
"Anwita Kalyanapu",
"Bryce Moore",
"Cali Copeland",
"Camily De Paula",
"Christian Mena",
"Christian Pompa",
"Cielo Rodriguez",
"Cristian Alicea", 
"Deanna Gumarova Mercie",
"Douglas Rivera",
"Erick Arias",
"Isaac Aristud",
"Jackson Le",
"Jaily De Paula", 
"Jeremiah Samuel",
"Jon Sarmento",
"Kaiya Varner",
"Katherine Gonzalez",
"Lukas Gibbs",
"Mackenzie Connole",
"Maria Leon",
"Marianne Franco",
"Megan Seppe",
"Melissa Herrera",
"Melvin Rodriguez",
"Mishka Cisneros",
"Nicholas Baez",
"Nickolas Hebert",
"Noah Timol",
"Paloma Rodriguez",
"Peter McDaniels",
"Rachel Oria",
"Renisha Ylluste",
"Sabrina Gonzalez",
"Santiago Ramirez",
"Taisiya Ivanchikova",
"Trevor Whiteside-Hamilton",
"Tyrese Dorce",
"Wasseem Barghouthi",
"Xansibella Pena",
"Yeneisi Calihua-Panzo",
];

const cohort2024_25 = [
  "Adam Becker", 
  "Adam Willis",
  "Alexa Ancheta",
  "Allison Phan",
  "Angelita Equite-Zarate",
  "Arely Serrano",
  "Ashley Rosas-Rios",
  "Balery Quinonez",
  "Benjamin Lewis", 
  "Bethany Spratt",
  "Bonnie Li",
  "Brenda Hernandez",
  "Brianna Bonilla", 
  "Claira Perez",
  "Diomary Orozco",
  "Elaine Buteau",
  "Estefania Diaz", 
  "Hillary Corrales",
  "Hyunwoo Kim",
  "Isabella Rojas",
  "Isabella Diaz", 
  "Jennifer Nicolas Lopez",
  "Jimmy Le",
  "Jordan Nguyen",
  "Joseangel Garcia",
  "Juan Yarala",
  "Justin Hovan",
  "Karma Deacon",
  "Kelvin Nguyen",
  "Ketlove Louica",
  "Khan Alam",
  "Kiara Hidalgo",
  "Kylie Spraggins",
  "Lissy Martinez",
  "Luisa Konageski Da Fonseca", 
  "Manel Cedeno Kampf",
  "Marcela Bados",
  "Matheus De Olivera De Moraes",
  "Melani Lamela",
  "Mia Ramirez",
  "Muhammed Enes Bilek", 
  "Mysha Khan",
  "Nathan Oliver", 
  "Nicole Marte",
  "Oscar Galicia-Merida", 
  "Pablo Barrios-Echevarria",
  "Patricio Flores", 
  "Rhianna Burton",
  "Ronald Lazo",
  "Sharon Sanju",
  "Simona Sartan",
  "Sofia Dyson",
  "Sophia Vigil",
  "Thinh Tran",
  "Yaxiel Nieves Natal",
];

const cohort2023_24 = [
  "Aleyna Tunch",
  "Anthony Menendez",
  "Ashley Del Valle",
  "Audrey Gabriel",
  "Berlyne Baptiste",
  "Brandon Martin",
  "Brenda Marquez-Solano",
  "Brianna Alvarez",
  "Catherine Valdes",
  "Christine Ngo",
  "Claudia Masmitja",
  "Daniel Permane",
  "Edgar Perez Vizcaino",
  "Elias Sandoval",
  "Elizabeth Hernandez",
  "Emily Paraboschi",
  "Fanny Chen",
  "Fatema Ashour",
  "Freddy Pardo",
  "Gabriela Torres",
  "Gonzalo Cabeza",
  "Isabella Acevedo",
  "Isabella Del Chiaro",
  "Jamsheed Gafur",
  "Johender Suarez",
  "Juan Lopez",
  "Julian Wences",
  "Katelyn Medina",
  "Keith Pecker",
  "Keshnee Alixe",
  "Kevin Bencomo",
  "Lara Salloum",
  "Laura Castellon",
  "Lauren Minor",
  "Leslie Torres",
  "Leticia Andrade",
  "Melissa Santiesteban",
  "Miguel Rodriguez",
  "Mohammed Alrubaye",
  "Monique Alfonso",
  "Natasha Counts",
  "Paris Brewton",
  "Sasha Hernandez-Rancel",
  "Shanna Chery",
  "Tanesha Pierre",
  "Yamariz Perez",
  "Yazmine Nunez",
  "Yona Ovdiyenko",
  "Yuridia Calihua-Panzo",
  "Zy'Keria Gamble",
];

const cohort2022_23 = [
  "Abdurrahman Bejjaj",
  "Alana Torres",
  "Aland Ortecho",
  "Alexis Woodward",
  "Alexis Zergott",
  "Alyssa Sa",
  "Amberina Khoja",
  "Anne Eugene",
  "Ariel Dookie",
  "Arnel Polo",
  "Braden Beaney",
  "Brandon Nguyen",
  "Cortney Smith",
  "Damian Rodriguez",
  "Danitsa Gonzales",
  "Elizabeth Menendez Socarras",
  "Elshamma Saint-Lot",
  "Grecia Ocando",
  "Isabella Nunez",
  "Isabella Rodriguez",
  "Isabella Perez",
  "Jacqueline Sipio",
  "Jay Xie",
  "Jayla Hostick",
  "Josue Zuniga",
  "Juliana Eubanks",
  "Julianna Syros",
  "Kashish Sachdeva",
  "Kennedy Wilkes",
  "Krista Tyre",
  "Lessley Osorio Perez",
  "Liliana Gonzalez-Alvanez",
  "Makayla Skidmore",
  "Marquis Viel",
  "Maxim Dillon",
  "Melissa Elmhorst",
  "Melissa Fraga",
  "Mia Aragon",
  "Miguel Pascual",
  "Nicolas Cavalcanti",
  "Nora Ripley",
  "Priyanka Harrypersad",
  "Rose Michelle Jeremie",
  "Saif Odeh",
  "Samantha Villafane",
  "Selin Ravelo",
  "Steffano Segovia-Palacios",
  "Tamirah Johnson",
  "Toshinari Minobe",
  "Victoria Tieze",
  "Viviana Gimon",
  "Yanet Serrano",
];

const cohort2021_22 = [
  "Aaron Chen",
  "Alexandra Quattrocki",
  "Ana Estrada",
  "Andrea Portillo-Sorto",
  "Andrew Bishop",
  "Andriana Detsis",
  "Ashley Henriquez",
  "Ashton Khan",
  "Brittany Barnes",
  "Diane Del Rio",
  "Daniela Martinez",
  "Emily Pecker",
  "Enya Doyle",
  "Florian Tacorian",
  "Hiba Karim",
  "Isabella Ortiz",
  "Javier Hurst",
  "Jenny Tran",
  "Jonathan Hernandez",
  "Julianna Miranda",
  "Karin Rashid",
  "Katrina Mrozowski",
  "Luna Pedrosa",
  "Mandy Tran",
  "Matthew Urra",
  "Mauricio Lara",
  "Mauricio Del Castillo",
  "Melanie Peña",
  "Raymond Persaud",
  "Salim Moutaouakkil",
  "Schayenne Hernandez",
  "Sophia Spata",
  "Shantzie Ponce",
  "Terrence Joseph",
  "Yahir Pena",
  "Zully Torres",
];

const cohort2020_21 = [
  "Andrew Jefferson Morales",
  "Shandia Lewis-Booker",
  "Lenna Menocal",
  "Serina Ferrer",
  "Carolina Katalina Sanchez",
  "Alexander J Munguia",
  "Reina Fortune",
  "Bailey McCracken",
  "Nathalie Are",
  "Sarah Gutierrez",
  "Quyen Nguyen",
  "Robert Fontan",
  "Adrian Fernandez",
  "Eklia St-Leger",
  "Isabella Ico",
  "Brianna Vo",
  "Ann Renee Saint Fleur",
  "Maria Kim Pham",
  "Jeniffer Maldonado ",
  "An Hoa Tran",
  "Britania Rowe",
  "Alyssa Singh",
  "Juan Garcia",
  "Precious Obiagwu ",
  "Shakira Bullock",
  "Mary Grant",
  "Kaitlyn Cabana",
  "Anne Thuy Le",
  "Juan Suarez ",
  "Keren Asghede",
];

const data = {
  cohort20_21: cohort2020_21,
  cohort21_22: cohort2021_22,
  cohort22_23: cohort2022_23,
  cohort23_24: cohort2023_24,
  cohort24_25: cohort2024_25,
  cohort25_26: cohort2025_26,
  cohort26_27: cohort2026_27
};
export default data;
